import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';
import { FinalFeedback } from './interfaces/final-feedback.interface';

@Injectable()
export class FinalFeedbackService {

  constructor(private _httpService: BackendService) { }

  public getFinalFeedback(cycle: number, cycleProcessConfigId: number): Observable<any> {
    return this._httpService.get('getFinalFeedbackRecord', [], [
      { 'name': 'cycleId', 'value': cycle as any },
      { 'name': 'cycleProcessConfigId', 'value': cycleProcessConfigId as any }
    ]);
  }

  public manageFinalFeedbackRecord(feedback: FinalFeedback): Observable<any> {
    return this._httpService.post('manageFinalFeedbackRecord', feedback);
  }

  public closeFinalFeedback(cycleParticipantId: number, cycleProcessConfigId: number): Observable<any> {
    return this._httpService.post('closeFinalFeedbackForUser', {
        'cycleParticipantId': cycleParticipantId,
        'cycleProcessConfigId': cycleProcessConfigId
    });
  }
  
  public reopenFinalFeedback(cycleParticipantId: number, cycleProcessConfigId: number): Observable<any> {
    return this._httpService.post('reopenFinalFeedbackForUser', {
        'cycleParticipantId': cycleParticipantId,
        'cycleProcessConfigId': cycleProcessConfigId
    });
  }
  
  public getSubordinatesForValidation(cycleProcessConfigId: number): Observable<any> {
    return this._httpService.get('getSubordinateFinalFeedbacks' , [], [
        { 'name': 'cycleProcessConfigId', 'value': cycleProcessConfigId as any }
    ]);
  }
  
  public saveFinalFeedbackValidation(userId:string, feedback: FinalFeedback): Observable<any> {
    return this._httpService.post('saveFinalFeedbackValidation', {
        'userId': userId,
        'feedback': feedback
    });
  }
  
  public getSubordinateFinalFeedback(cycleProcessConfigId: number, userId: string, cycleId: number): Observable<any> {
    return this._httpService.get('getSubordinateFinalFeedbackForValidation', [], [
        { 'name': 'cycleProcessConfigId', 'value': cycleProcessConfigId as any } ,
        { 'name': 'userId', 'value': userId as any },
        { 'name': 'cycleId', 'value': cycleId as any }
        ]);
  }
  
  public saveFinalFeedbackReview(feedback: FinalFeedback) {
    return this._httpService.post('saveFinalFeedbackReview', feedback);
  }

  public finishFinalFeedback(cycleParticipantId: number, cycleProcessConfigId: number): Observable<any> {
      return this._httpService.post('finishFinalFeedback', {
            'cycleParticipantId': cycleParticipantId,
            'cycleProcessConfigId': cycleProcessConfigId
      });
  }

}
